import React from 'react';
import 'codemirror/lib/codemirror.css';
import '@toast-ui/editor/dist/toastui-editor.css';
import { Editor } from '@toast-ui/react-editor';
import './CustomEditor.scss';
import { isLongScreen } from '../../utils/ScreenUtil';
const toolBars = [
  'heading',
  'bold',
  'italic',
  'quote',
  'divider',
  'ul',
  'ol',
  'link',
  'htmlInline',
  'redo',
  'undo',
];

class CustomEditor extends React.Component {
  constructor(props) {
    super(props);
    this.editorRef = React.createRef();
    this.initialValue = props.initialValue;
    this.onValueChange = props.onValueChange || (() => {});
    this.errorMessage = props.errorMessage;
    this.onFocus = props.onFocus || (() => {});
    this.customStyle = props?.customStyle;

    this.state = { editorValue: props.initialValue };
  }

  componentDidUpdate(prevProps) {
    if (!prevProps.initialValue && this.props.initialValue) {
      this.editorRef.current.getInstance().setMarkdown(this.props.initialValue);
    }
  }

  render() {
    return (
      <>
        <div
          className={`customer-editor-container ${
            this.props.error ? 'editor-container-error' : ''
          } ${isLongScreen ? '' : 'customer-editor-container-short '}`}
          onFocus={() => this.onFocus()}
          style={this.customStyle}
        >
          <Editor
            events={{
              change: () => {
                const markdown = this.editorRef.current
                  .getInstance()
                  .getMarkdown();
                // console.log('@@122-56: ', this.state.editorValue, markdown);
                if (
                  markdown !== this.state.editorValue &&
                  (markdown || this.state.editorValue)
                ) {
                  this.onValueChange(markdown);
                  this.setState({ editorValue: markdown });
                }
              },
            }}
            initialValue={this.initialValue}
            previewStyle="vertical"
            height="270px"
            useCommandShortcut={true}
            initialEditType="wysiwyg"
            hideModeSwitch={true}
            toolbarItems={toolBars}
            ref={this.editorRef}
            // useDefaultHTMLSanitizer={true}
            customHTMLSanitizer={(html) => {
              // console.log('@@74: ', html);
              // console.log('@@74: ', html.replace(/<span[^>]*>?/gm, ''));
              return `${html
                .replace(/<\/?span[^>]*>/gm, '')
                .replace(/<\/?label[^>]*>/gm, '')}`;
              // return `<b>${html}</b>`;
            }}
          />
        </div>
        {this.props.error ? (
          <label className="editor-container-error-message">
            {this.props.errorMessage}
          </label>
        ) : null}
      </>
    );
  }
}

export default CustomEditor;
